// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ce_a bhl_h bhl_kf bhl_wb bhl_ss bhl_vr bhl_su bhl_sl"};